/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1PayoutWallet
 */
export interface V1PayoutWallet {
    /**
     * TON address (raw or user-friendly); empty when none is set
     */
    wallet: string
}

/**
 * Check if a given object implements the V1PayoutWallet interface.
 */
export function instanceOfV1PayoutWallet(
    value: object
): value is V1PayoutWallet {
    if (!('wallet' in value) || value['wallet'] === undefined) return false
    return true
}

export function V1PayoutWalletFromJSON(json: any): V1PayoutWallet {
    return V1PayoutWalletFromJSONTyped(json, false)
}

export function V1PayoutWalletFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1PayoutWallet {
    if (json == null) {
        return json
    }
    return {
        wallet: json['wallet']
    }
}

export function V1PayoutWalletToJSON(json: any): V1PayoutWallet {
    return V1PayoutWalletToJSONTyped(json, false)
}

export function V1PayoutWalletToJSONTyped(
    value?: V1PayoutWallet | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        wallet: value['wallet']
    }
}
